// extracted by mini-css-extract-plugin
export default {"category":"Category_category__fGL5l","categoryList":"Category_categoryList__LgpyZ"};